<template>
  <div class="chart-container">
    <div class="chart-container-header">
      <div class="title">
        {{ $t('stats_income_sources.title') }}
      </div>
      <div class="mode-slider">
        <div
          @click="mode = 'systems'"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'systems' }"
        >
          {{ $t('stats_income_sources.by_system') }}
        </div>
        <div
          @click="mode = 'menus'"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'menus' }"
        >
          {{ $t('stats_income_sources.by_menu') }}
        </div>
        <div
          @click="mode = 'waiters'"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'waiters' }"
        >
          {{ $t('stats_income_sources.by_waiter') }}
        </div>
        <div
          @click="mode = 'sections'"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'sections' }"
        >
          {{ $t('stats_income_sources.by_halls') }}
        </div>
      </div>
    </div>
    <div class="chart-container-box">
      <div class="donut-box">
        <vc-donut
          background="#e5e5e5"
          foreground="transparent"
          :size="27.77777777777778"
          unit="vh"
          :thickness="20"
          :total="100"
          :sections="renderableSections"
        ></vc-donut>
      </div>
      <div class="chart-legend-container">
        <div
          v-for="section in textSections"
          :key="section.label"
          class="legend-line"
        >
          <div
            :style="`background:${section.color}`"
            class="section-color"
          ></div>
          {{ section.label }}
          <span :style="`color:${section.color}`"
            >{{ section.value }}% | {{ formatNumber(section.total) }} ₴</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mode: 'systems',
      color_palette: [
        "#149C82",
        // "#189D84",
        // "#1C9E85",
        // "#20A087",
        // "#24A189",
        // "#28A28B",
        // "#2CA38C",
        "#30A48E",
        // "#33A690",
        // "#37A792",
        // "#3BA893",
        // "#3FA995",
        "#43AA97",
        // "#47AC99",
        // "#4BAD9A",
        // "#4FAE9C",
        // "#52AF9E",
        // "#56B19F",
        "#5AB2A1",
        // "#5EB3A3",
        // "#62B4A4",
        // "#66B6A6",
        // "#6AB7A8",
        // "#6EB8AA",
        // "#72B9AB",
        // "#76BBAD",
        // "#7ABCAF",
        "#7DBDB1",
        // "#81BEB2",
        // "#85BFB4",
        // "#89C1B6",
        // "#8DC2B8",
        // "#91C3B9",
        // "#95C4BB",
        // "#99C5BD",
        "#9DC7BF",
        // "#A1C8C0",
        // "#A4C9C2",
        // "#A8CAC4",
        "#AECCC6",
      ],
    };
  },
  props: {
    datasets: Object
  },
  methods: {
     formatNumber(raw) {
      if (!raw || isNaN(raw)) return 0;

      return (+raw).toFixed(2); 
    }
  },
  computed: {
    currentDataset() {
      return this.datasets[this.mode];
    },
    textSections() {
      return this.currentDataset.map((d,i) => {
        return {
          label: d.label,
          total: d.total,
          value: d.percent,
          color: this.color_palette[i % this.color_palette.length]
        }
      });
    },  
    renderableSections() {
      let total_percent = 0;
      return this.currentDataset.map((d,i) => {
        total_percent += d.percent;
        let value = total_percent <= 100 ? d.percent : d.percent - 1;
        if (i == this.currentDataset.length-1 && total_percent < 100) {
          value++;
        } 
        return {
          value,
          color: this.color_palette[i % this.color_palette.length]
        }
      });
    }
    
  }
};
</script>
<style scoped>
.chart-container {
  width: 100%;
  padding: 2.222vh;
  background: #e5e5e5;
  border-radius: 1.333vh;
  margin-top: 3.333vh;
  box-sizing: border-box;
}
.chart-container-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.222vh;
}
.title {
  font-size: 2.777vh;
  line-height: 3.222vh;
  display: flex;
  align-items: center;
  color: #908f8d;
}
.mode-slider {
  height: 3.666h;
  background: #ededed;
  border-radius: 0.444vh;
  display: flex;
}
.mode-slide-btn {
  width: 15.777777777777779vh;
  height: 3.666vh;
  border-radius: 0.444vh;
  font-size: 2vh;
  line-height: 2.3333333333333335vh;
  color: #908f8d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.active-mode {
  background: #1d1d1b;
  color: #ededed;
}
.chart-container-box {
  display: flex;
  width: 100%;
  padding: 2.222vh;
  align-items: center;
  justify-content: space-between;
}
.donut-box {
  width: calc(50% - 2.22vh);
  height: 27.77777777777778vh;
}
.chart-legend-container {
  width: calc(50% - 2.22vh);
}
.legend-line {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #1d1d1b;
  display: flex;
  align-items: center;
  margin-bottom: 2.222vh;
}
.legend-line:last-child {
  margin-bottom: 0;
}
.legend-line span {
  margin-left: 1.1111vh;
}
.section-color {
  width: 2.222vh;
  height: 2.222vh;
  border-radius: 0.333vh;
  margin-right: 1.1111vh;
}
</style>
